//
//
//
//
//
//
//
//
//


export default {
    name: "BottomNav",

    data() {
        return {
            active: 0,
            tabbars: [
                {
                    path: "/",
                    title: "悦家园",
                    normal:
                        require('@/assets/img/ico-01-0.png'),
                    active:
                        require('@/assets/img/ico-01-1.png')
                },
                {
                    path: "/active",
                    title: "悦活动",
                    normal:
                        require('@/assets/img/ico-02-0.png'),
                    active:
                        require('@/assets/img/ico-02-1.png')
                },
                {
                    path: "/serve",
                    title: "悦服务",
                    normal:
                        require('@/assets/img/ico-03-0.png'),
                    active:
                        require('@/assets/img/ico-03-1.png')
                },
                {
                    path: "/shop",
                    title: "悦实惠",
                    normal:
                        require('@/assets/img/ico-04-0.png'),
                    active:
                        require('@/assets/img/ico-04-1.png')
                }
                ,
                {
                    path: "/user",
                    title: "悦会员",
                    normal:
                        require('@/assets/img/ico-05-0.png'),
                    active:
                        require('@/assets/img/ico-05-1.png')
                }
            ]
        };
    },
    methods: {},
    //通过路由跳转判断选中的样式
    created() {
        if (this.$route.name == "home") {
            this.active = 0;
        } else if (this.$route.name == "active") {
            this.active = 1;
        } else if (this.$route.name == "serve") {
            this.active = 2;
        } else if (this.$route.name == "shop") {
            this.active = 3;
        } else if (this.$route.name == "user") {
            this.active = 4;
        }
    }
};
